import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  matchFieldsStepText: {
    defaultMessage: 'Match Fields',
    id: 'OpNgkt',
    description: 'Text to inform user which step in the process of CSV order import they are in',
  },
});
